import { Checkbox, FormControlLabel, FormGroup } from '@material-ui/core';
import React, { useMemo } from 'react';
import { Share } from '../../interfaces/article';
import ArticleField from '../ArticleField';

interface SharePickerProps {
    value: Share,
    onChange: (new_value: Share) => void,
}

function shareToBool(share: Share): boolean[] {
    return {
        [Share.NoShare]: [false, false],
        [Share.Share]: [true, false],
        [Share.ShareNow]: [true, true],
    }[share];
}

function boolToShare(share: boolean, now: boolean): Share {
    if (share) {
        if (now) {
            return Share.ShareNow
        } else {
            return Share.Share
        }
    } else {
        return Share.NoShare
    }
}

const SharePicker = (props: SharePickerProps) => {
    const [share, shareNow] = useMemo(() => shareToBool(props.value), [props.value]);

    return <ArticleField label="Partager">
        <FormGroup>
            <FormControlLabel
                control={<Checkbox checked={share} onChange={e => {
                    props.onChange(boolToShare(e.target.checked, shareNow))
                }}/>}
                label="Partager sur les réseaux"
            />
            { share && 
            <FormControlLabel
                control={
                    <Checkbox checked={shareNow} onChange={e => {
                        props.onChange(boolToShare(share, e.target.checked));
                }}/>}
                label="Partager maintenant"
            />}
        </FormGroup>
    </ArticleField>
}

export default SharePicker;